import { render } from "./icon-gr-team.svg?vue&type=template&id=0fd03865?inline"
const script = {}
script.render = render

export default script